import { Table } from "mta-rkvr-styles";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { get } from "../api/fetch";
import { ProceedingInProgressResponseBody } from "../api/HomePageResponseTypes";
import { ColumnHeader, ProceedingInProgress } from "../types/homepage/ProceedingInProgress";
import { Paginator } from "../types/util/TableFunctionalityTypes";
import { mapClassifiersValuesToLabels } from "../util/classifierManager";
import { PROCEEDINGS } from "../util/paths";

const ProceedingsInProgress = () => {
  const { t } = useTranslation();
  const tBase = "homePageAuth.proceedingsInProgress.";
  const title = useMemo(() => t(tBase + "title"), []);

  const [proceedings, setProceedings] = useState<ProceedingInProgress[]>();
  const [proceedingsRowsIds, setProceedingsRowsIds] = useState<number[]>();
  const [isLoading, setLoading] = useState(false);
  const tableHeaders = useMemo(() => Object.keys(ColumnHeader).map((header) => t(tBase + header)), []);

  useEffect(() => {
    getProceedings();
  }, []);

  const getProceedings = (pageSize?: number, elementOffset?: number) => {
    if (isLoading) {
      return;
    }
    setLoading(true);
    get<ProceedingInProgressResponseBody>({
      endPoint: "proceedingsInProgress",
      queryParams: [
        { name: "limit", value: pageSize ? pageSize : 10 },
        { name: "offset", value: elementOffset ? elementOffset : 0 },
      ],
    }).then(async (res) => {
      if (res.ok) {
        const { body } = res;
        const { resultsList: messages } = body;
        const labelsObject = await mapClassifiersValuesToLabels([
          {
            type: "menetlusType",
            values: messages.map((message) => message.liik),
          },
          {
            type: "menetlusTypeSubtype",
            values: messages.map((message) => message.alamliik),
          },
          {
            type: "menetlusStateTypes",
            values: messages.map((message) => message.seisund),
          },
        ]);

        setProceedingsRowsIds(messages.map((row) => row.menetluseId));
        setProceedings(
          messages.map((message) => {
            return {
              ...message,
              liik: {
                label: labelsObject.menetlusType!.shift()!,
                value: message.liik,
              },
              alamliik: {
                label: labelsObject.menetlusTypeSubtype!.shift()!,
                value: message.alamliik,
              },
              seisund: {
                label: labelsObject.menetlusStateTypes!.shift()!,
                value: message.seisund,
              },
            };
          }),
        );
        setPaginator({
          elementOffset: body.offset,
          numberOfElements: body.resultCount,
          pageSize: body.limit,
          totalElements: body.totalCount,
        });
      }
      setLoading(false);
    });
  };
  const [paginator, setPaginator] = useState<Paginator>();

  const onPagination = (paginator: { pageSize: number; elementOffset: number }) => {
    getProceedings(paginator.pageSize, paginator.elementOffset);
  };

  return (
    <Table
      id={"ProceedingsInProgress"}
      title={title}
      headers={tableHeaders}
      paginator={paginator}
      onPagination={onPagination}
      content={
        proceedings
          ? proceedings.map((proceeding) => {
              const { menetluseId, number, liik, alamliik, seisund, lisainfo } = proceeding;
              return {
                number: <Link to={`${PROCEEDINGS}/${menetluseId}`}>{number}</Link>,
                liik: liik.label,
                alamliik: alamliik.label,
                seisund: seisund.label,
                lisainfo,
              };
            })
          : []
      }
      translate={t}
      wrapBigColumns
      rowIds={proceedingsRowsIds}
      collapsable
      loading={isLoading}
    />
  );
};

export default ProceedingsInProgress;
